angular.module('zc.zenclerkS')
  .factory('InvoiceAdjustment', invoiceAdjustmentFactory);

invoiceAdjustmentFactory.$inject = ['$q', 'Api'];
function invoiceAdjustmentFactory($q, Api) {
  return class InvoiceAdjustment {
    static all(project) {
      return Api.get(`/api/projects/${project.id}/invoice_adjustments/`, {}, {cache: false})
        .then(res => {
          if(!res.data.success) {
            return $q.reject(res);
          }
          return res.data.invoice_adjustments;
        });
    }

    static show(project, month) {
      return Api.get(`/api/projects/${project.id}/invoice_adjustments/${month}`, {}, {cache: false})
        .then(res => {
          if(!res.data.success) {
            return $q.reject(res);
          }
          return res.data.invoice_adjustments;
        });
    }

    static remove(project, id) {
      return Api.delete(`/api/projects/${project.id}/invoice_adjustments/${id}`)
        .then(res => {
          if(!res.data.success) {
            return $q.reject(res);
          }
          return res.data.invoice_adjustment;
        });
    }

    static create(project, invoiceAdjustmentObj) {
      return Api.post(`/api/projects/${project.id}/invoice_adjustments/`, { invoice_adjustment: invoiceAdjustmentObj })
        .then(res => {
          if(!res.data.success) {
            return $q.reject(res);
          }
          return res.data.invoice_adjustment;
        });
    }
  };
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/services/invoice_adjustment.service.js